
<div class="jumbotron">
    <div style="text-align: center;">
        <h1 class="display-4">South West Centres</h1>
        <p class="lead">A warm welcome from the South West Centres</p>
        <p class="lead">Visit our <a href="https://www.facebook.com/southwestcentres.co.uk/" target="_blank"> facebook page</a></p>
    </div>
    <div class="alert alert-primary mb-0" role="alert" style="text-align: center;">
        <h4>SOUTH WEST CENTRES EVENT at Cirencester Park 1st July to 7th July 2026</h4>
      
        <h4>To coincide with THE COTSWOLD SHOW AND FOOD FESTIVAL 4th and 5th July 2026</h4>

        <p>NOTE: Pets are very welcome to attend this event, unfortunately though they are not permitted in the marquees</p>
    </div>
</div>


